import { render, staticRenderFns } from "./BookNowButton.vue?vue&type=template&id=00ef1e3e&scoped=true&"
import script from "./BookNowButton.vue?vue&type=script&lang=js&"
export * from "./BookNowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef1e3e",
  null
  
)

export default component.exports